/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechPcLaptopIcon16Solid = forwardRef('TechPcLaptopIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M4.5 2A2.5 2.5 0 0 0 2 4.5v4A2.5 2.5 0 0 0 4.5 11h7A2.5 2.5 0 0 0 14 8.5v-4A2.5 2.5 0 0 0 11.5 2h-7Z" }),
        React.createElement("path", { d: "M14.55 11.027a.75.75 0 1 0-1.164.946l1.038 1.277H1.576l1.038-1.277a.75.75 0 1 0-1.164-.946L.412 12.304c-.797.98-.1 2.446 1.164 2.446h12.848c1.263 0 1.96-1.466 1.164-2.446l-1.038-1.277Z" })));
});
